import * as React from 'react';

function SvgClock(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <circle fill="none" cx={10} cy={10} r={7.25} stroke={props.color} strokeWidth={1.5} />
      <path
        fill="none"
        d="M10 6v4.5h3.5"
        stroke={props.color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default SvgClock;
